import styled from "@emotion/styled";

export const BannerRoot = styled.section`
  width: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
`;

export const BannerInner = styled.div`
  width: 100%;
  min-height: 82px;
  padding: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    min-height: 60px;
    padding: 0 16px;
  }
`;

export const BannerText = styled.h2`
  margin: 0;
  font-family: ui-serif, Georgia, "Times New Roman", serif;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.35px;
  text-transform: uppercase;
  color: #1f1f1f;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 15px;
    line-height: 1.35;
  }
`;
